module.exports = __webpack_public_path__ + "static/media/anna.18117c30.gif";